import type { SVGProps } from "react";
export interface HeadMedicalIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HeadMedicalIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HeadMedicalIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.376 9c0 .621-.505 1.125-1.126 1.126H7.875v.75H9.25c.622 0 1.126.503 1.126 1.125v1.373h.75v-1.373c0-.622.503-1.125 1.125-1.125h1.373v-.75h-1.373A1.125 1.125 0 0 1 11.126 9V7.625h-.75zm3-1.125h.874c.898 0 1.624.728 1.624 1.625v2c0 .897-.726 1.626-1.624 1.626h-.874V14c0 .898-.729 1.624-1.627 1.624H9.75A1.624 1.624 0 0 1 8.125 14v-.874H7.25a1.626 1.626 0 0 1-1.625-1.627V9.5c0-.897.727-1.624 1.625-1.625h.875V7c0-.898.728-1.625 1.625-1.625h2c.897 0 1.625.727 1.626 1.625z"
      />
      <path
        fill={color}
        d="M2.875 22v-3.81c0-.863-.331-1.396-.882-2.505C1.446 14.585.875 13.207.875 11 .875 5.14 5.141.875 11 .875c4.878 0 8.384 3.602 9.519 7.945l.364 1.396c.365 1.353.758 2.573 1.442 3.642l.414.646.088.15c.85 1.548-.193 3.496-1.995 3.609l-.813.05-.212 2.014a3.124 3.124 0 0 1-3.107 2.797H14A4.125 4.125 0 0 1 9.875 19a1.125 1.125 0 0 1 2.25 0c0 1.035.84 1.875 1.875 1.875h2.7a.875.875 0 0 0 .87-.783l.223-2.12.029-.19a2.125 2.125 0 0 1 1.95-1.708l.92-.057.052-.01a.196.196 0 0 0 .122-.242l-.022-.048-.415-.646c-1.147-1.794-1.622-3.9-2.087-5.68-.943-3.608-3.728-6.266-7.342-6.266-4.617 0-7.875 3.258-7.875 7.875 0 1.745.429 2.772.882 3.684.449.903 1.118 1.99 1.118 3.507V22a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
